// src/modules/app-views/omnichannel/pages/Init/modals/EscalateModal/Step1.jsx
// *******************************************************************************
// ESCALATE MODAL - STEP 1
// *******************************************************************************

// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { useState, useCallback } from 'react';
import { Alert, Form, Select } from 'antd';
import translateX from 'utils/translateX';

// *******************************************************************************
// STEP CONTENT COMPONENT
// *******************************************************************************
const EscalateStep1Content = () => {
  // ---------------------------------------------------------------------------
  // STATE
  // ---------------------------------------------------------------------------
  const [selectOpen, setSelectOpen] = useState(false);

  // ---------------------------------------------------------------------------
  // HANDLERS
  // ---------------------------------------------------------------------------

  // ANTD v6 fix: controlled open state ensures dropdown closes on first click
  const handleSelect = useCallback(() => {
    setSelectOpen(false);
  }, []);

  const handleOpenChange = useCallback(visible => {
    setSelectOpen(visible);
  }, []);

  // ---------------------------------------------------------------------------
  // LOCAL VARIABLES
  // ---------------------------------------------------------------------------
  const destinationOptions = [
    { value: 'crm', label: translateX('escalate_to_crm') },
    { value: 'serviceOrder', label: translateX('escalate_to_ticket') },
    { value: 'order', label: translateX('escalate_to_order') },
  ];

  // ---------------------------------------------------------------------------
  // UI
  // ---------------------------------------------------------------------------
  return (
    <>
      <Alert
        title={translateX('escalate_service')}
        description={translateX('escalate_description')}
        type="info"
        showIcon
        style={{ marginBottom: 16 }}
      />

      <Form.Item
        name="entityType"
        label={translateX('select_destination')}
        rules={[{ required: true, message: () => translateX('required_field') }]}
      >
        <Select
          open={selectOpen}
          onSelect={handleSelect}
          onOpenChange={handleOpenChange}
          options={destinationOptions}
          placeholder={translateX('select_destination')}
        />
      </Form.Item>
    </>
  );
};

// *******************************************************************************
// STEP CONFIGURATION
// *******************************************************************************
const escalateStep = () => ({
  stepTitle: 'escalate_service',
  stepTooltip: 'escalate_service',
  content: () => <EscalateStep1Content />,
  validationFields: ['entityType'],
});

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default escalateStep;
